import type * as Recharts from 'recharts';
import type { Theme } from '@mui/material/styles';

export interface PhaseData extends PhaseDetail {
  weight: number;
}

export interface PhaseDetail {
  phase: number;
  type: PhaseTypes;
}

export interface IPhasesCurveController {
  getData: (props: GraphConfigProperties) => [Array<PhaseData>, EndPhases | undefined];
  getPhasesLength: () => number;
  //getEndSystoleDiastolePhases: () => EndPhases;
  readonly currentPhasePercentage: number | undefined;
  setPhase: (index: number) => Promise<void>;
  setEndPositions: (endPhases: EndPhases) => void;
  initializeEndPositions: () => void;
  finalizeEndPositions: () => void;
  isImagesLoadingCompleted: boolean;
  isCineloopActive: boolean;
  isCineloopAvailable: boolean;
}

export interface ICineloopControlController {
  playCineloop: (shouldStartPlay: boolean) => Promise<void>;
}

export interface IChartLabelParams {
  phasesData: Array<PhaseData>;
  phase: number;
  graphKind: GraphKind;
  isExpanded: boolean;
}

export type GraphKind = 'RVVolume' | 'AnnulusSize';
export type LabelPosition = Recharts.LabelProps['position'];

export enum GraphKinds {
  RVVolume = 'RVVolume',
  AnnulusSize = 'AnnulusSize'
}

export enum AbsoluteShiftValues {
  RVVolume = 20,
  AnnulusSize = 2
}

export type ChartCache = Record<string, LabelPosition>;

export interface ICustomDotProps extends Recharts.DotProps {
  payload: PhaseData;
}

export type ExtendedCustomDotProps = ICustomDotProps & {
  disabled: boolean;
  radius: number;
  inverted?: boolean;
  sw?: number;
};

export enum PhaseTypes {
  Systole = 'Systole',
  Diastole = 'Diastole'
}

export enum PhaseCurveDotRadius {
  Default = 4,
  Active = 7
}

export interface EndPhases {
  [PhaseTypes.Systole]: { phase: number; index: number };
  [PhaseTypes.Diastole]: { phase: number; index: number };
}
export interface GraphConfigProperties {
  label: string;
  units: string;
  unitsLabel: string;
  paramName: string;
  factor: number;
}

export type GraphKindConfig = Record<GraphKinds, GraphConfigProperties>;

export interface IChartCurveProps {
  phasesData: Array<PhaseData>;
  isImagesLoadingCompleted: boolean;
  grabbedReferenceLine: PhaseTypes | undefined;
  isReferenceLinePicked: boolean;
  theme: Theme;
}

export const CONTAINER_MARGIN = 120;
export const EXTENDED_CONTAINER_MARGIN = 250;
